import { render, staticRenderFns } from "./PaymentAndDelivery.vue?vue&type=template&id=3aa65401&lang=pug&"
import script from "./PaymentAndDelivery.vue?vue&type=script&lang=js&"
export * from "./PaymentAndDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports